import { FormattedMessage } from 'react-intl';
import { useAppNavigate, useAppSelector } from '../../../configuration/setup/hooks';
import { isPersonalInfoValid } from '../personal.validators';
import { isAppInMaintenanceMode } from '../../../configuration/tmpSlice';
import { ROUTE_CONSENTS } from '../../app/routes/routes';

export const PersonalNextButton = () => {
    const isValid = useAppSelector(state => !isAppInMaintenanceMode(state) && isPersonalInfoValid(state.personalInfo));
    const navigate = useAppNavigate();
    return (
        <button
            type={'button'}
            disabled={!isValid}
            onClick={e => {
                e.preventDefault();
                navigate(ROUTE_CONSENTS);
            }}
            className={'btn btn-primary btn-icon-right personal-data-next-button'}
        >
            <span className={'rioglyph rioglyph-chevron-right'} />
            <FormattedMessage id={'registration.companyData.nextButtonLabel'} />
        </button>
    );
};
